import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const deleteParcel = {
  name: "deleteParcel" as const,
  input: z.object({ name: z.string() }),
  output: zNull(),
};
